<template>
  <div v-if="isLoading">
    <LoadingPlaceholder/>
  </div>
  <div v-else>
    <Breadcrumbs
      :breadcrumbs="[
        {title: this.$t(`menu.${serviceSlug}`), disabled: true},
        {title: this.$t('menu.iframe/media-library'), active: true, meta: {type: 'string', value: `/${this.iframeService.slug}/${this.iframeService.slug}/media-library`}},
        {title: media.name, disabled: true}
      ]"/>

    <div>
      <h5 class="text-evollu-gray-light is-bold mb-0 pl-3 py-3"> {{$t('iframe.titles.update_media')}} </h5>

      <MediaDetail
        v-model="mediaForm"
        :formErrors="mediaErrors"
        :collapsable="true"
        :clientOptions="clientOptions"
      />

      <!-- Buttons row -->
      <div class="row d-flex justify--space-between mt-3 ml-3 mr-3">
        <va-button class="btn-cancel" @click="handleCancel">
          {{$t('iframe.actions.cancel')}}
        </va-button>

        <va-button @click="handleSave" :disabled="!canSubmit">
          {{$t('iframe.actions.save')}}
        </va-button>
      </div>
      <!-- --- --- --- -->


    </div>

  </div>
</template>

<script>
import Breadcrumbs from "@/components/common/Breadcrumbs";
import {IframeService} from "@/api/IframeService";
import LoadingPlaceholder from "@/components/common/LoadingPlaceholder";
import MediaDetail from "@/components/iframe/media-library/MediaDetail";
import Errors from "@/utils/StandardErrors";

const errorsPrefix = 'iframe.media_library.errors.'

export default {
  props: {
    serviceSlug: {
      type: String,
      required: true
    },
  },
  components: {MediaDetail, LoadingPlaceholder, Breadcrumbs},
  data() {
    return {
      isLoading: true,
      mediaForm: {
        icon: null,
        lang: null,
        name: null,
        sound: null,
        client: null,
      },
      mediaErrors: new Errors(),
      media: null,
    }
  },
  async mounted() {
    try {
      const resp = await IframeService.getMediaById(this.$route.params.id)
      this.media = resp.data

      this.isLoading = false
      this.prefillForm()
    } catch (err) {
      //todo handle err
      console.log(err)
    }
  },
  methods: {
    prefillForm: function() {
      this.mediaForm = this.media
      this.mediaForm.lang = this.$store.state.languages.find(lang => lang.lang === this.mediaForm.lang)
    },
    handleCancel: function() {
      this.$router.push({path:`/${this.iframeService.slug}/${this.iframeService.slug}/media-library`})
    },
    handleSave: function() {
      this.isSubmiting = true
      let formDataToSubmit = {...this.mediaForm}

      if(this.mediaForm.lang) {
        formDataToSubmit.lang = this.mediaForm.lang.lang
      }
      let formData = new FormData()

      delete(formDataToSubmit.client_id)
      Object.entries(formDataToSubmit).forEach(([key, val]) => {
        if(key === "client") {
          formData.append("clientId", val.id.toString())
        } else {
          formData.append(key, val)
        }
      })

      IframeService.updateMedia(this.mediaForm.id, formData, (formData.icon !== null || formData.sound !== null))
        .then(res => {
          this.showToast(this.$t('iframe.media_library.update_success'), this.$store.state.successToastOptions)
          this.handleCancel()
        })
        .catch(errors => {
          console.log(errors)
          if(errors.response.status === 422) {
            this.mediaErrors.record(errors.response.data.errors, errorsPrefix)
          }
          this.showToast(this.$t('iframe.media_library.update_error'), this.$store.state.errorToastOptions)
        })
        .finally(() => { this.isSubmiting = false } )
    }
  },
  computed: {
    iframeService: function () {
      return this.$store.state.services.find(service => service.slug === 'iframe') || null
    },
    entities: function () {
      return this.iframeService ? this.iframeService.entities : null
    },
    canSubmit() {
      return (this.mediaForm.name !== null && this.mediaForm.name !== '') && !this.isSubmiting && this.mediaForm.icon !== null && this.mediaForm.sound !== null && this.mediaForm.client !== null
    },
    clientOptions: function () {
      //let iframeService = this.$store.state.services.find(service => service.url === this.$store.state.iframe_server) || null
      if (this.iframeService) {
        if (this.iframeService.user_permissions.some(perm => perm.entity_id === null)) {
          if(this.iframeService.entities.length === 1) {
            this.mediaForm.client = this.iframeService.entities[0]
          }
          return this.iframeService.entities
        }
        const consideredEntitiesIds = this.iframeService.user_permissions.filter(perm => perm.access_type >= 1 && perm.info_type === 120).map(elem => elem.entity_id)
        const consideredEntities = this.iframeService.entities.filter(entity =>  consideredEntitiesIds.includes(entity.id))
        if (consideredEntities.length === 1) {
          this.mediaForm.client = consideredEntities[0]
        }
        return consideredEntities
      }
      return []
    },
  }
}
</script>

<style scoped>

</style>
